/**
 * @flow
 *
 */

import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import {
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  FormFeedback,
  Input,
  Label,
  FormText,
  // Alert,
} from 'reactstrap';

import { getDesignName } from '~/selectors/global';

type PropsType = {
  name: string,
  onHide(): void,
  onSubmit(name: string): void,
  onUpdate(name: string): void,
  setName(name: string): void,
  show: boolean,
  loading: boolean,
  designId: number,
  error: string,
  warning: string,
  initialName: string,
};

type StateType = {
  name: string,
  error: string,
  dirty: boolean,
  lastError: string,
};

const NAME_LENGTHS = [1, 30];

// eslint-disable-next-line react/prefer-stateless-function
export class SaveDesignModal extends React.Component<PropsType, StateType> {
  static defaultProps = {
    show: false,
    error: '',
    warning: '',
    name: '',
  };

  props: PropsType; // eslint-disable-line react/sort-comp
  state: StateType = {
    name: '',
    error: '',
    dirty: false,
    lastError: '',
  };

  constructor(props: PropsType) {
    super(props);

    this.state = {
      name: props.initialName || '',
      error: props.error,
      lastError: props.error,
      dirty: false,
    };
  }

  static getDerivedStateFromProps(
    nextProps: PropsType,
    prevState: StateType,
  ): StateType {
    // console.log('gDSFP', nextProps, prevState);

    // console.log('dirty', prevState.dirty, prevState.name, nextProps.name);
    return {
      ...prevState,
      name: prevState.name,
      error: nextProps.error,
      lastError: nextProps.error,
    };
  }

  render() {
    const {
      onHide,
      onSubmit,
      // onUpdate,
      loading,
      initialName = '',
    } = this.props;

    const { name, error } = this.state;

    const isValidLength =
      name.length > NAME_LENGTHS[0] && name.length < NAME_LENGTHS[1];

    const isValid = isValidLength;

    const isUpdatingDesign = initialName.length > 0;
    // const isSameDesignName = isUpdatingDesign && initialName === name;

    const hasError = error.length > 0;
    const isErrorNameExists = error.startsWith('Design name');
    const isErrorNameExistsEqual =
      isErrorNameExists && error.match(RegExp(`'${name}'`)) !== null;

    const submitHandler = (e: InputEvent) => {
      e.preventDefault();

      // if (isUpdatingDesign || e.target.name === 'overwrite') {
      //   onUpdate(`${this.props.designId}/${name}`);
      //   return;
      // }

      onSubmit(name);
    };

    const handleOnChange = (e: InputEvent) => {
      const value = e.target.value;
      this.setState(({ lastError }) => {
        // Check if the user tries to use the same  name after an error
        const val = value.replace(/[^\w-]+/g, '-');
        if (lastError.match(RegExp(`'${val}'`))) {
          return {
            name: val,
            dirty: true,
            error: lastError,
          };
        }

        // Changed the name - clear any errors
        return { name: val, error: '', dirty: true, };
      });
    };

    const getFeedbackText = () => {
      if (!isValidLength)
        return `Name length must be between ${NAME_LENGTHS[0]} and ${
          NAME_LENGTHS[1]
        } characters.`;

      if (error) {
        if (!isErrorNameExists || !isUpdatingDesign) return error;

        if (isUpdatingDesign && isErrorNameExistsEqual && !loading)
          return (
            <div
              className="d-flex"
              style={{
                alightItems: 'baseline',
                justifyContent: 'space-between',
              }}
            >
              <div>{error}</div>
            </div>
          );
      }

      // return '\u00A0';
      return '';
    };

//     const getAlert = () => (
//       <Alert className="w-100" color={isSameDesignName ? 'warning' : 'info'}>
//         {isSameDesignName
//           ? `Warning: Using the same name will overwrite the saved design with the current parameters.\
// This action cannot be undone.`
//           : 'Note: You are saving a copy of the current design.'}
//       </Alert>
//     );

    const feedback = getFeedbackText();
    const hasFeedback = typeof feedback === 'object' || feedback.length > 0;

    const inputValue = this.state.dirty ? name : '';

    return (
      <Modal isOpen={this.props.show} toggle={onHide}>
        <ModalHeader toggle={onHide}>Save Design</ModalHeader>
        <ModalBody className="row">
          <Col sm={10}>
            <Form onSubmit={submitHandler}>
              <FormGroup>
                <Label for="designName">Design Name</Label>
                <Input
                  type="text"
                  bsSize="lg"
                  invalid={!isValid || (hasError && !loading)}
                  placeholder={process.env.REACT_APP_INITIAL_DESIGN_NAME}
                  onChange={handleOnChange}
                  value={inputValue}
                  disabled={loading}
                />
                {hasFeedback && <FormFeedback>{feedback}</FormFeedback>}
                {loading && (
                  <FormText>Saving...</FormText>
                )}
              </FormGroup>
            </Form>
          </Col>
          { /* isUpdatingDesign && getAlert() */ }
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            id="submit"
            type="submit"
            onClick={submitHandler}
            disabled={!isValid || loading || isErrorNameExistsEqual}
          >
            Save
          </Button>
          <Button color="secondary" onClick={onHide}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  const error = state.global.records.error || '';
  const initialName = getDesignName(state) || '';
  // const designId = getDesignName(state) || '';
  const { loading, current: designId } = state.global.records;

  return {
    loading,
    error,
    initialName,
    designId,
  };
}

// $FlowIgnore
const withRedux = connect(mapStateToProps);

const enhancer = compose(withRedux);

export default enhancer(SaveDesignModal);



// WEBPACK FOOTER //
// ./src/components/SaveDesignModal/SaveDesignModal.js